import type { ClientLayoutConfig } from '@/entities/client-config/model/clientConfig.types'
import type { OrdersBoardColumn } from '@/widgets/orders-board'
import { createColumnConfig } from '@/widgets/orders-board/orders-board.config'

const DASHBOARD_COLUMNS: OrdersBoardColumn[] = [
  createColumnConfig('delivering', {
    emptyMessage: 'No orders are being delivered',
    className: 'section-delivering',
    dataOnboarding: 'section-delivering',
    name: 'delivering',
    mobileViewComponent: 'compactOrderCardCarousel',
  }),
  createColumnConfig('arrived', {
    emptyMessage: 'No orders have arrived',
    className: 'section-arrived',
    dataOnboarding: 'section-arrived',
    name: 'arrived',
    mobileViewComponent: 'compactOrderCardCarousel',
  }),
  createColumnConfig('onTheWay', {
    emptyMessage: 'No orders are on the way',
    className: 'section-on-the-way',
    dataOnboarding: 'section-on-the-way',
    name: 'onTheWay',
    mobileViewComponent: 'compactOrderCardCarousel',
  }),
]

export const layoutConfig: ClientLayoutConfig = {
  middle: {
    columns: DASHBOARD_COLUMNS,
  },
}
